import * as React from 'react';

import { Skeleton } from 'antd';
import { Column, Row, Space, Text } from 'farmhub-ui-core';
import moment from 'moment';

import { useAppSelector } from 'app';
import { env } from 'env';
import { selectAppState } from 'slice';
import { formatAppearPhoneNumber, getFullAddress } from 'utils/function';

import Paragraph from '../components/Paragraph';
import GroupProductTable from './components/GroupProductTable';
import {
  CQRCode,
  WrapperContent,
  WrapperNote,
  WrapperSignature,
} from './styles';

interface ElectronicBillContentProps {
  order: any;
  isLoading: boolean;
  onChangeOrderInfo?: (val: any) => void;
  onCreateImage?: () => void;
  padding?: string;
}

const NormalBillContent = ({
  order,
  isLoading,
  onChangeOrderInfo,
  onCreateImage,
  padding,
}: ElectronicBillContentProps): JSX.Element => {
  const app = useAppSelector(selectAppState);
  const [orderInfo, setOrderInfo] = React.useState<any>({});

  const handleUpdateData = (val: any) => {
    if (typeof val === 'object' && val !== null) {
      onChangeOrderInfo && onChangeOrderInfo(val);
      setOrderInfo((prevState: any) => {
        return {
          ...prevState,
          ...val,
        };
      });
      onCreateImage && onCreateImage();
    }
  };

  const handleClearData = (e: any, val: any) => {
    e.stopPropagation();
    if (typeof val === 'object' && val !== null) {
      setOrderInfo((prevState: any) => {
        return {
          ...prevState,
          ...val,
        };
      });
    }
  };

  return (
    <WrapperContent className="bill-content" padding={padding}>
      <Row justifyContent="space-between" styles={{ gap: 12 }} width="100%">
        <Column styles={{ gap: 2 }} width="100%">
          {isLoading ? (
            <>
              <Row justifyContent="center">
                <div>
                  <Skeleton.Input
                    size="small"
                    style={{ width: '120px', alignItems: 'center' }}
                  />
                  <Space height={3} />
                  <Skeleton.Input
                    size="small"
                    style={{ width: '120px', alignItems: 'center' }}
                  />
                  <Space height={3} />
                  <Skeleton.Input
                    size="small"
                    style={{ width: '120px', alignItems: 'center' }}
                  />
                </div>
              </Row>
              <Space height={6} />
            </>
          ) : (
            <>
              <Row justifyContent="center" width="100%">
                <Text
                  color="black"
                  lineHeight="20px"
                  styles={{
                    flexShrink: 0,
                    fontSize: '18px',
                    fontWeight: '700 !important',
                  }}
                  weight="bold"
                >
                  PHIẾU XUẤT KHO
                </Text>
              </Row>
              <Space height={3} />

              <Row justifyContent="center" width="100%">
                <div>
                  <Row
                    alignItems="flex-start"
                    justifyContent="center"
                    width="100%"
                  >
                    {/* <Text
                      lineHeight="20px"
                      color="black"
                      weight="bold"
                      styles={{
                        width: 'fit-content',
                        marginRight: '3px',
                        flexShrink: 0,
                      }}
                    >
                      Ngày:
                    </Text> */}
                    <Paragraph
                      align="center"
                      style={{
                        width: 'fit-content',
                      }}
                      weight="extraBold"
                      onSubmit={(e: any) => {
                        handleUpdateData({ time: e });
                      }}
                    >
                      {orderInfo?.time ??
                        `Ngày: ${moment().format('DD/MM/YYYY')}`}
                    </Paragraph>
                  </Row>
                  <Row
                    alignItems="flex-start"
                    justifyContent="center"
                    width="100%"
                  >
                    {/* <Text
                      lineHeight="20px"
                      color="black"
                      weight="bold"
                      styles={{
                        width: 'fit-content',
                        marginRight: '3px',
                        flexShrink: 0,
                      }}
                    >
                      Khách hàng:
                    </Text> */}
                    <Paragraph
                      align="center"
                      weight="extraBold"
                      onSubmit={(e: any) => {
                        handleUpdateData({ customerName: e });
                      }}
                    >
                      {orderInfo?.customerName ??
                        `Khách hàng: ${
                          order.customer?.displayName || 'Ẩn danh'
                        }`}
                    </Paragraph>
                  </Row>
                </div>
              </Row>
              <Space height={6} />
            </>
          )}
        </Column>
        {isLoading ? (
          <Skeleton.Input style={{ width: 64, height: 64 }} />
        ) : order?.code ? (
          <CQRCode
            level="L"
            value={`${
              app?.domains?.hubBilling?.domain ?? env.service.hubbillingWebApp
            }/${order.code}`}
          />
        ) : (
          <></>
        )}
      </Row>
      <Space height={6} />
      <GroupProductTable isLoading={isLoading} order={order} />
      <WrapperNote id="signature" isLoading={isLoading}>
        <Row
          alignItems="flex-start"
          styles={{
            padding: '4px',
          }}
        >
          {isLoading ? (
            <Skeleton.Input
              size="small"
              style={{ width: '100px', alignItems: 'center' }}
            />
          ) : (
            <>
              <Row styles={{ 'flex-shrink': 0 }} width="fit-content">
                <Text color="black" lineHeight="22px">
                  Ghi chú của KH:
                </Text>
              </Row>
              <Space width={6} />
              <Paragraph
                weight="extraBold"
                onSubmit={(e: any) => {
                  handleUpdateData({ customerNote: e });
                }}
              >
                {orderInfo?.customerNote ?? (order?.customerNote || '')}
              </Paragraph>
            </>
          )}
        </Row>
      </WrapperNote>
      <WrapperNote id="signature" isLoading={isLoading}>
        <Row
          alignItems="flex-start"
          styles={{
            padding: '4px',
          }}
        >
          {isLoading ? (
            <Skeleton.Input
              size="small"
              style={{ width: '100px', alignItems: 'center' }}
            />
          ) : (
            <>
              <Row styles={{ 'flex-shrink': 0 }} width="fit-content">
                <Text color="black" lineHeight="22px">
                  Ghi chú của NCC:
                </Text>
              </Row>
              <Space width={6} />
              <Paragraph
                weight="extraBold"
                onSubmit={(e: any) => {
                  handleUpdateData({ supplierNote: e });
                }}
              >
                {orderInfo?.supplierNote ?? (order?.supplierNote || '')}
              </Paragraph>
            </>
          )}
        </Row>
      </WrapperNote>
      <WrapperSignature id="signature" isLoading={isLoading}>
        <Row
          alignItems="flex-start"
          styles={{
            'border-right': `1px solid ${isLoading ? '#f0f0f0' : 'black'}`,
            padding: '4px',
          }}
          width="50%"
        >
          <Column>
            {isLoading ? (
              <Skeleton.Input
                size="small"
                style={{ width: '200px', alignItems: 'center' }}
              />
            ) : (
              <>
                <Text color="black">Người giao hàng:</Text>
                <Paragraph
                  weight="extraBold"
                  onSubmit={(e: any) => {
                    handleUpdateData({ deliveryInfo: e });
                  }}
                >
                  {orderInfo?.deliveryInfo ?? ''}
                </Paragraph>
              </>
            )}
          </Column>
        </Row>
        <Row alignItems="flex-start" styles={{ padding: '4px' }} width="50%">
          <Column>
            {isLoading ? (
              <>
                <Skeleton.Input
                  size="small"
                  style={{ width: '200px', alignItems: 'center' }}
                />
                <Space height={3} />
                <Skeleton.Input
                  size="small"
                  style={{ width: '200px', alignItems: 'center' }}
                />
              </>
            ) : (
              <>
                <Text color="black">Người nhận hàng: </Text>
                <Paragraph
                  weight="extraBold"
                  onSubmit={(e: any) => {
                    handleUpdateData({ receivedInfo: e });
                  }}
                >
                  {orderInfo?.receivedInfo ??
                    `${
                      order.additionalInfo?.address?.title
                    } ${formatAppearPhoneNumber(
                      order.additionalInfo?.address?.phoneNumber
                    )}, ${getFullAddress(
                      order.additionalInfo?.address?.address,
                      order.additionalInfo?.address?.district?.fullName,
                      order.additionalInfo?.address?.province?.fullName,
                      order.additionalInfo?.address?.ward?.fullName
                    )}`}
                </Paragraph>
              </>
            )}
          </Column>
        </Row>
      </WrapperSignature>
    </WrapperContent>
  );
};

export default NormalBillContent;
